<h1 mat-dialog-title>Nuevo contrato de partner</h1>
<mat-dialog-content [formGroup]="form">
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Inicio</mat-label>
        <input matInput [matDatepicker]="start_picker" formControlName="start_date" />
        <mat-datepicker-toggle matIconSuffix [for]="start_picker"></mat-datepicker-toggle>
        <mat-datepicker #start_picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Fin (opcional)</mat-label>
        <input matInput [matDatepicker]="end_picker" formControlName="end_date" />
        <mat-datepicker-toggle matIconSuffix [for]="end_picker"></mat-datepicker-toggle>
        <mat-datepicker #end_picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Departamentos</mat-label>
        <mat-select formControlName="department_ids" multiple>
          @for (department of departments(); track department.id) {
            <mat-option [value]="department.id">
              {{ department.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="form.invalid || saving()" (click)="save()">Crear</button>
</mat-dialog-actions>
